(function (app, ng) {

    app.component("productionGoal",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/Components/ProductionGoal/production-goal.component-template.html",
            controller: productionGoalController,
            bindings: {
                year: "<"
            }
        });

    productionGoalController.$inject = ["arcBusinessApi", "$filter", "figToaster"];
    function productionGoalController(arcBusinessApi, $filter, figToaster) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                loadingData: false
            });

        function setChart(response) {

            var colors = ['#f33334', '#74abe2', '#4cba6b', '#955196', '#f29b1d', '#9ea8ad'];
            var color = {};        
            [color.red, color.blue, color.green, color.purple, color.orange, color.grey] = colors;

            $ctrl.chart = {
                options: {
                    scales: {
                        xAxes: [{
                            scaleLabel: {
                                display: true,
                                labelString: 'Premium Amount (USD)'
                            },
                            ticks: {
                                callback: function (value) {
                                    return $filter('currency')(value, '$', 0);
                                }
                            }
                        }],
                        yAxes: [{
                            gridLines: {
                                display: false
                            }
                        }]
                    },
                    tooltips: {
                        callbacks: {
                            //the callback obj in this case contains the key (yLabel) & value (xLabel) of the tooltip
                            label: function (obj) {
                                var data = obj.xLabel;
                                return " " + $filter('currency')(data, '$', 0);
                            }
                        }
                    }                 
                },              
                labels: ['YTD', 'Production Goal'],
                data: Object.values(response),
                colors: [color.blue, color.orange]
            };
        }

        function getPremiumByYear(year) {
            var message = '';
            var toastClass = '';
            $ctrl.message = false;
            $ctrl.loadingData = true;
            arcBusinessApi.getAgentPremiumAmountByYear(year)
                .then(function (response) {
                    data = response.results;               
                })
                .catch(function () {
                    data = {
                        ProductionGoal: 0,
                        TotalProduction: 0
                    };
                    message = "There's a problem retrieving your data. Please try again shortly.";
                    toastClass = "is-error";
                    return figToaster.showSimple(message, "top", toastClass);
                })
                .finally(function () {
                    $ctrl.loadingData = false;
                    setChart(data);
                });
        }

        $ctrl.$onInit = function () {
            $ctrl.loadingData = false;
            getPremiumByYear($ctrl.year);
        };

        $ctrl.$onChanges = function () {
            getPremiumByYear($ctrl.year);
        };
    }

})(window.app, window.angular); //jshint ignore:line